export default "__VITE_ASSET__Bmn75G3y__"